// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__12IEp","shimmer":"styles_shimmer__GbFty"};